/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISiloLike, ISiloLikeInterface } from "../ISiloLike";

const _abi = [
  {
    inputs: [],
    name: "siloAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISiloLike__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloLikeInterface {
    return new utils.Interface(_abi) as ISiloLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloLike {
    return new Contract(address, _abi, signerOrProvider) as ISiloLike;
  }
}
